import { ItemTypes } from '../../internal/constants/ItemTypes';
import { IItem } from '../interfaces/IItem';

export const createItemParamsFromIds = (ids: string[], type: ItemTypes) => <IItem[]>ids.map(
        (id) => ({
            type,
            params: { id }
        })
    );
